export const selectTopOpportunitiesByBestFitData = (state) =>
  state.capture.topOpportunitiesByBestFit.data;

export const selectTopOpportunitiesByBestFitLoading = (state) =>
  state.capture.topOpportunitiesByBestFit.isLoading;

export const selectTopOpportunitiesByBestFitError = (state) =>
  state.capture.topOpportunitiesByBestFit.error;
